import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=605e4436&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"
import style0 from "./Widget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Widget.vue?vue&type=style&index=1&id=605e4436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e4436",
  null
  
)

export default component.exports